import { Link } from 'react-router-dom';
import logo from '../images/logo.png';

const LandingHeader = ({ onSignIn, variant = 'landing' }) => {
  if (variant === 'simple') {
    return (
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 sm:gap-3">
            <img src={logo} alt="Inbox Mate" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
            <span className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight">Inbox Mate</span>
          </Link>
          <Link
            to="/"
            className="text-sm text-blue-600 hover:text-blue-700 font-medium"
          >
            Back to Home
          </Link>
        </div>
      </header>
    );
  }

  return (
    <div className="sticky top-4 z-50 px-4 sm:px-6 pt-2 pb-6 sm:pt-3 sm:pb-8 mb-8 sm:mb-12 md:mb-16">
      <div className="bg-white/80 backdrop-blur-md border border-gray-200 rounded-full shadow-sm px-6 py-3 flex items-center justify-between w-full max-w-[1400px] mx-auto">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity">
          <img src={logo} alt="Inbox Mate" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
          <div className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight">Inbox Mate</div>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <a href="/#features" className="text-gray-600 hover:text-gray-900 font-medium transition-colors">Features</a>
          <a href="/#pricing" className="text-gray-600 hover:text-gray-900 font-medium transition-colors">Pricing</a>
          <Link to="/blog" className="text-gray-600 hover:text-gray-900 font-medium transition-colors">Blog</Link>
          <a href="/#faq" className="text-gray-600 hover:text-gray-900 font-medium transition-colors">FAQ</a>
          {onSignIn && (
            <button
              onClick={onSignIn}
              className="ml-4 px-5 py-2 border-2 border-gray-300 text-gray-700 font-semibold rounded-full hover:border-gray-400 hover:bg-gray-50 transition-all"
            >
              Log in
            </button>
          )}
        </nav>
        {onSignIn && (
          <button
            onClick={onSignIn}
            className="md:hidden px-4 py-2 border-2 border-gray-300 text-gray-700 text-sm font-semibold rounded-full hover:border-gray-400 hover:bg-gray-50 transition-all"
          >
            Log in
          </button>
        )}
      </div>
    </div>
  );
};

export default LandingHeader;
